import React, { useCallback, useContext } from 'react';
import AccordionContext from './context/accordion-context';
import useOpenStatus from './hooks/use-open-status';
import noop from '../utils/noop';

// @ts-ignore TS(2322): Type 'string' is not assignable to type 'ReactElem... Remove this comment to see the full error message
function AccordionHeader({
  component: Component = 'div',
  itemId,
  onClick = noop,
  children,
  ...otherProps
}) {
  // @ts-ignore TS(2339): Property 'toggleItemOpen' does not exist on type '... Remove this comment to see the full error message
  const { toggleItemOpen } = useContext(AccordionContext);
  const isOpen = useOpenStatus(itemId);
  const toggleOpen = useCallback(() => {
    onClick(itemId, isOpen);
    toggleItemOpen(itemId);
  }, [toggleItemOpen, itemId, isOpen, onClick]);

  return (
    // @ts-ignore TS(2604): JSX element type 'Component' does not have any con... Remove this comment to see the full error message
    <Component {...otherProps} onClick={toggleOpen}>
      {typeof children === 'function' ? children(isOpen) : children}
    </Component>
  );
}

export default AccordionHeader;
